export const formatNumber = (value: number) =>
  value.toLocaleString("es-PY", { minimumFractionDigits: 0, maximumFractionDigits: 2 });

export const formatCurrency = (value: number) =>
  value.toLocaleString("es-PY", {
    style: "currency",
    currency: "PYG",
    maximumFractionDigits: 0,
  });

export const ensureText = (value: unknown) => {
  if (typeof value === "string") return value;
  if (value == null) return "";
  return String(value);
};

export const resolveUsuarioActual = () => {
  if (typeof window === "undefined") {
    return "Usuario no identificado";
  }
  const raw =
    sessionStorage.getItem("authUser") ||
    localStorage.getItem("authUser") ||
    sessionStorage.getItem("user") ||
    localStorage.getItem("user");
  if (!raw) return "Usuario no identificado";
  try {
    const parsed = JSON.parse(raw);
    const nestedUser =
      parsed?.usuario ||
      parsed?.user ||
      parsed?.usuarioSesion ||
      parsed?.datosUsuario ||
      parsed?.data?.usuario ||
      parsed?.data?.user;
    const candidates = [
      parsed?.name,
      parsed?.fullName,
      parsed?.username,
      parsed?.email,
      parsed?.userName,
      nestedUser?.nombre,
      nestedUser?.nombreUsuario,
      nestedUser?.username,
      nestedUser?.fullName,
      nestedUser?.email,
    ];
    const firstString = candidates.find(
      (value) => typeof value === "string" && value.trim().length > 0,
    );
    if (firstString) {
      return ensureText(firstString);
    }
    return ensureText(raw);
  } catch {
    return ensureText(raw);
  }
};

export const getPreviousDate = (dateStr: string) => {
  const parsed = new Date(`${dateStr}T00:00:00`);
  if (Number.isNaN(parsed.getTime())) {
    return dateStr;
  }
  parsed.setDate(parsed.getDate() - 1);
  return parsed.toISOString().slice(0, 10);
};

export const normalizeBranchFilterValue = (value?: string | null) => {
  if (!value) return "";
  const candidate = Array.isArray(value) ? value[0] : value;
  if (candidate == null) return "";
  const trimmed = String(candidate).trim();
  if (!trimmed) return "";
  const upper = trimmed.toUpperCase();
  const canonical = upper
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^A-Z0-9]/g, "");
  if (canonical === "ESPANA" || canonical === "ESPAA") {
    return "ESPAA";
  }
  return trimmed;
};

export const normalizeBranchCanonical = (value?: string | null) => {
  if (!value) return "";
  return value
    .trim()
    .toUpperCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^A-Z0-9]/g, "");
};

export const normalizeBranchKey = (value?: string | null) => {
  const canonical = normalizeBranchCanonical(value);
  return canonical.length > 0 ? canonical : "SINDEPOSITO";
};

export const formatBranchLabel = (value?: string | null) => {
  const normalized = normalizeBranchFilterValue(value);
  return normalized.length > 0 ? normalized : "Sin depósito";
};

export const formatHeaderDate = (value?: string | null) => {
  if (!value) {
    return "";
  }
  const parsed = new Date(`${value}T00:00:00`);
  if (Number.isNaN(parsed.getTime())) {
    return value;
  }
  return parsed.toLocaleDateString("es-PY", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  });
};

export const formatShortDayMonth = (value: string) => {
  const parsed = new Date(`${value}T00:00:00`);
  if (Number.isNaN(parsed.getTime())) {
    return value;
  }
  return parsed.toLocaleDateString("es-PY", {
    day: "2-digit",
    month: "2-digit",
  });
};

export const truncateWithDots = (value: string, maxLength: number) => {
  const text = String(value ?? "");
  if (text.length <= maxLength) return text;
  const safeLen = Math.max(0, maxLength - 2);
  return `${text.slice(0, safeLen).trimEnd()}..`;
};
